import { useFormik } from 'formik';
import { StatusCodes } from 'http-status-codes';
import React, { useState } from 'react';
import styled from 'styled-components';
import * as yup from 'yup';
import ButtonComponent from '~/src/components/common/forms/Button/ButtonComponent';
import SecondaryButton from '~/src/components/common/forms/Button/SecondaryButton';
import TextInputComponent from '~/src/components/common/forms/TextInput/TextInputComponent';
import FnbApi from '~/src/services/api/FnbApi';

const schema = yup.object().shape({
  svilaGtin: yup.string().required(),
});

interface Props {
  fnbItem: any;
}
export default function FnbItemRow({ fnbItem }: Props): JSX.Element {
  const [statusSvila, setStatusSvila] = useState('');
  const [statusFnb, setStatusFnb] = useState('');

  const update = async (values, setSubmitting) => {
    setStatusSvila('Svila: saving...');
    const res = await FnbApi.updateSvilaGtins(fnbItem.code, values.svilaGtin);
    if (res.status === StatusCodes.NO_CONTENT) {
      setStatusSvila('Svila: saved.');
    } else {
      setStatusSvila('Svila: error.');
    }

    setStatusFnb('Fnb: saving...', fnbItem.gombaProductId);
    const res2 = await FnbApi.updateFnbSvilaGtins(fnbItem.gombaProductId, values.svilaGtin);
    if (res2.status === StatusCodes.NO_CONTENT) {
      setStatusFnb('Fnb: saved.');
    } else {
      setStatusFnb('Fnb: error.');
    }
  };

  const formik = useFormik({
    initialValues: {
      svilaGtin: '',
    },
    validationSchema: schema,
    onSubmit: (values, { setSubmitting }) => {
      return update(values, setSubmitting);
    },
  });

  return (
    <tr key={fnbItem.id}>
      <td> {fnbItem.gombaProductId} </td>
      <td> {fnbItem.code}</td>
      <td> {fnbItem.name}</td>
      <td>
        <FormWrapper
          onSubmit={formik.handleSubmit}
          autoComplete="off"
          style={{ display: 'flex', flexDirection: 'row' }}
        >
          <div style={{ marginRight: 15 }}>
            <TextInputComponent
              name="svilaGtin"
              value={formik.values.svilaGtin}
              inline={true}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              errors={formik.errors}
              touched={formik.touched}
              height="27"
            />
          </div>
          <SecondaryButton title="Save" type="submit" />
          {statusSvila} {statusFnb}
        </FormWrapper>
      </td>
    </tr>
  );
}

const FormWrapper = styled.form`
  display: flex;
  align-items: center;
`;
